import React from "react"
import StaffListing from "../../newComponents/staffList";

const relatedTeamMembers = ({ block }) => (
  <section className="section-listing js-section-listing">
    <div className="shell">
      {block.headline ?
        <header className="section__head">
          <p className="section__title title h2 text-gray">{block.headline}</p>
        </header>
        :
        <></>
      }
      <div className="boxes swiper-container js-load-more js-slider-boxes-projects">
        <ul>
          <StaffListing staff={block.featuredTeamMembers} keyBase="related-team-members"/>
        </ul>
        <div className="swiper-pagination boxes__pagination" />
      </div>
    </div>
  </section>
)

export default relatedTeamMembers;